import { useEffect, useState } from "react";
import { toast } from "@/lib/toast";
import { X, WarningCircle, CheckCircle, Info } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

interface Toast {
  id: string;
  message: string;
  type: "error" | "success" | "info";
}

const icons = {
  error: WarningCircle,
  success: CheckCircle,
  info: Info,
};

const styles = {
  error: "border-rose-200 bg-rose-50 text-rose-800",
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  info: "border-blue-200 bg-blue-50 text-blue-800",
};

const iconStyles = {
  error: "text-rose-500",
  success: "text-emerald-500",
  info: "text-blue-500",
};

export function Toaster() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    return toast.subscribe(setToasts);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm">
      {toasts.map((t) => {
        const Icon = icons[t.type];
        return (
          <div
            key={t.id}
            className={cn(
              "flex items-start gap-3 rounded-lg border px-4 py-3 shadow-lg animate-in slide-in-from-right-full duration-300",
              styles[t.type]
            )}
          >
            <Icon className={cn("mt-0.5 size-4 shrink-0", iconStyles[t.type])} />
            <p className="text-sm font-medium flex-1">{t.message}</p>
            <button
              onClick={() => toast.dismiss(t.id)}
              className="shrink-0 rounded p-0.5 opacity-60 hover:opacity-100 transition-opacity"
            >
              <X className="size-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
